import _find from 'lodash/find';
import moment from 'moment';

import saleService from 'api/sale';
import urlUtils from 'utils/urlUtils';

const PAGE_SIZE = 50;

function Ctrl($scope, $rootScope, $q, $stateParams, affiliateService, query, loggerService) {
  $scope.pageSize = PAGE_SIZE;
  $scope.pageNumber = 0;

  if ($stateParams.start) {
    $scope.startDate = parseInt($stateParams.start, 10);
  } else {
    $scope.startDate = moment().startOf('week').toDate().getTime();
  }

  if ($stateParams.end) {
    $scope.endDate = parseInt($stateParams.end, 10);
  } else {
    $scope.endDate = moment().endOf('week').toDate().getTime();
  }

  $scope.sales = [];

  $scope.selectedTrackingId = null;

  $scope.$watch('selectedTrackingId', val => {
    if (!$scope.initialized) {
      return;
    }

    if (!val) {
      $scope.selectedTrackingId = null;
    } else {
      query.set('trackingId', val);
    }

    _getSales();
  });

  $scope.loading = true;

  affiliateService.listTrackers({
      id: $scope.affiliate.id
    })
    .then(response => {
      $scope.trackingLinks = response;

      $scope.initialized = true;

      if ($stateParams.trackingId) {
        const tracker = _find(response, {
          _id: $stateParams.trackingId
        });

        if (tracker) {
          $scope.selectedTrackingId = tracker.id;
        }
      } else {
        _getSales();
      }
    })
    .catch(error => {
      loggerService.error(error);
    });

  $scope.datePickerOptions = {
    startDate: moment($scope.startDate),
    endDate: moment($scope.endDate),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'This Week': [moment().startOf('week'), moment().endOf('week')],
      'Last Week': [moment().startOf('week').subtract(7, 'days'), moment().subtract(1, 'weeks').endOf('week')],
      'Last 30 Days': [moment().subtract(30, 'days'), moment()],
      'Last 90 Days': [moment().subtract(90, 'days'), moment()],
      'Last 6 Months': [moment().subtract(6, 'month'), moment()],
      'This Year': [moment().startOf('year'), moment().endOf('year')]
    },
    onDatesSelected: (start, end) => {
      $scope.startDate = start.startOf('day').toDate().getTime();
      $scope.endDate = end.endOf('day').toDate().getTime();

      _getSales();
    }
  };

  $scope.resetPaging = function() {
    $scope.pageNumber = 1;
  };

  $scope.getPreviousPage = function($event) {
    if ($event) {
      $event.preventDefault();
    }

    $scope.pageNumber -= 1;

    return _getSales(true);
  };

  $scope.getNextPage = function($event) {
    if ($event) {
      $event.preventDefault();
    }

    $scope.pageNumber += 1;

    return _getSales(true);
  };

  $scope.downloadCsv = function($event) {
    if ($event) $event.preventDefault();

    const options = {
      start: $scope.startDate,
      end: $scope.endDate,
      trackingId: $scope.selectedTrackingId,
      skip: ($scope.pageNumber - 1) * PAGE_SIZE,
      limit: PAGE_SIZE,
      csv: true
    };

    const apiUrl = urlUtils.apiUrl(`/affiliate/${$scope.affiliate.id}/sale`, options);

    console.log('API URL', apiUrl);

    window.open(apiUrl);
  };

  function _getSales(page) {
    $scope.loading = true;

    if (!page) {
      $scope.resetPaging();
    }

    $q.resolve(saleService.listByAffiliateId($scope.affiliate.id, {
        start: $scope.startDate,
        end: $scope.endDate,
        trackingId: $scope.selectedTrackingId,
        skip: ($scope.pageNumber - 1) * PAGE_SIZE,
        limit: PAGE_SIZE
      }))
      .then(response => {
        $scope.loading = false;
        $scope.sales = response;
      })
      .catch(error => {
        loggerService.error(error);
      });
  }
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$q',
  '$stateParams',
  'tl.affiliate.service',
  'tl.query',
  'loggerService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/sales/salesCtrl.js